if (!customElements.get('review-wall')) {
  const DESKTOP_QUERY = '(min-width: 900px)';

  class ReviewWall extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('[data-carousel-row]');
      this.desktop = window.matchMedia(DESKTOP_QUERY);

      this.querySelectorAll('[data-review-more]').forEach((button) => {
        button.addEventListener('click', () => this.#toggle(button));
      });

      this.resize = new ResizeObserver(this.#measure);
      if (this.row) this.resize.observe(this.row);
      this.desktop.addEventListener('change', this.#measure);

      this.#measure();
    }

    disconnectedCallback() {
      this.resize?.disconnect();
      this.desktop?.removeEventListener('change', this.#measure);
    }

    #measure = () => {
      this.querySelectorAll('[data-review-more]').forEach((button) => {
        const body = document.getElementById(button.getAttribute('aria-controls'));
        if (!body) return;
        const open = button.getAttribute('aria-expanded') === 'true';
        const clamped = !this.desktop.matches && body.scrollHeight > body.clientHeight + 1;
        button.hidden = this.desktop.matches || !(open || clamped);
      });
    };

    #toggle(button) {
      const body = document.getElementById(button.getAttribute('aria-controls'));
      const open = button.getAttribute('aria-expanded') !== 'true';
      body?.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? button.dataset.labelLess : button.dataset.labelMore;
    }
  }

  customElements.define('review-wall', ReviewWall);
}
